import { useEffect } from 'react';
import { useParams } from 'react-router';
import { WithRouteData } from '../../../render-routes';
import {
  sendManagerEvent,
  useUserCtxSelector,
  useUserStateMatches,
} from '../../../xstate/app.xstate';
import { IPage } from '../../types';
import { TeamDetails } from './team-details';
import { getLoggedInUserHighestRole } from '../../../xstate/permission-details-xstate-helper';
import { NEW_TEAM_TEMP_ID } from '../../../xstate/team-details-xstate-helper';

export const TeamDetailsPage = (props: IPage) => {
  const params = useParams();
  const { org_id: orgIdQueryParam = '', team_id: teamIdQueryParam = '' } =
    params;
  const isNewTeam = teamIdQueryParam === NEW_TEAM_TEMP_ID;
  const loadedLoggedInUserDetails = useUserStateMatches('loggedIn.loaded');
  const { assignedRoles, assignedTeams } = useUserCtxSelector((ctx) => ({
    assignedRoles: ctx.user?.assignedRoles,
    assignedTeams: ctx.user?.assignedTeams,
  }));

  const loggedInUserHighestRole = getLoggedInUserHighestRole(
    assignedRoles,
    assignedTeams
  );

  useEffect(() => {
    if (loadedLoggedInUserDetails) {
      if (isNewTeam) {
        sendManagerEvent({
          type: 'manager.teamDetails.initiateNewTeam',
          orgId: orgIdQueryParam,
          loggedInUserHighestRole: loggedInUserHighestRole || {},
        });
      } else {
        sendManagerEvent({
          type: 'manager.teamDetails.loadTeamDetails',
          orgId: orgIdQueryParam,
          teamId: teamIdQueryParam,
          loggedInUserHighestRole: loggedInUserHighestRole || {},
        });
      }
    }
  }, [
    teamIdQueryParam,
    orgIdQueryParam,
    loadedLoggedInUserDetails,
    isNewTeam,
    loggedInUserHighestRole,
  ]);

  useEffect(() => {
    return () => {
      sendManagerEvent({
        type: 'manager.teamDetails.discardUpdates',
        teamId: teamIdQueryParam,
      });
    };
  }, [teamIdQueryParam]);

  return <TeamDetails {...props} isNewTeam={isNewTeam} />;
};

export default WithRouteData(TeamDetailsPage);
